import { render, staticRenderFns } from "./QuesDetailPage.vue?vue&type=template&id=1503ff9f&scoped=true&"
import script from "./QuesDetailPage.vue?vue&type=script&lang=js&"
export * from "./QuesDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./QuesDetailPage.vue?vue&type=style&index=0&id=1503ff9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503ff9f",
  null
  
)

export default component.exports